export default `
unsigned long newtime;
unsigned long oldtime;
unsigned long diffTime;
unsigned long VMTtime;
unsigned long nextIgnition = 0;
long int rpm;
bool modulator;
bool ignitionWasFired;
bool ignitionFlag;
bool ignitionFlagWithOffset;
bool oldModulator;
float ignitionDegree;



void setup()

{ 
   newtime=micros();
   oldtime=micros();
//  Serial.begin(115200); //Default Baudrate
  pinMode(1, OUTPUT);
  pinMode(0, INPUT);
//  Serial.print("LOADED");
}

void readrpm()
{
  newtime=micros();
  diffTime = newtime-oldtime;
  rpm = 60000000/diffTime;
//  Serial.print("RPM");
//  Serial.print(rpm);
}

void countIgnitionTime() {
  nextIgnition = (500000 * (360 - ignitionDegree)) / (3 * rpm) + VMTtime;
  ignitionFlagWithOffset = true;
}

void loop() {
  
  modulator = digitalRead(0);
  if (micros() >= nextIgnition && ignitionFlagWithOffset == true) {
    digitalWrite(1, HIGH);
    ignitionFlagWithOffset = false;
  }
//  if (ignitionFlag == false) {
//    digitalWrite(1, LOW);
//  } 

  if (ignitionFlag == true) {
    digitalWrite(1, HIGH);
    ignitionFlag = false;
  }
  if (modulator != oldModulator) {
    oldModulator = modulator;
    
    if(modulator == {{typeShutter}}) {
      digitalWrite(1, LOW);
      return; 
    }
    
    VMTtime = micros();

    // 1000-2.2; 2000-15; 3000-25.1

    readrpm();
    ignitionFlag = true;
    if (rpm >= 0 && rpm <= 700) {
        oldtime=micros();
        ignitionFlag = true;
        return;
    }
    if (rpm >= 700 && rpm <= 1000) { // 0 - 2.2
       ignitionDegree = {{param1x}} * rpm + ({{param1y}});
     }
     if (rpm >= 1000 && rpm <= 2000) { // 2.2 - 15
       ignitionDegree = {{param2x}} * rpm + ({{param2y}});
     }
     if (rpm >= 2000 && rpm <= 3000) { // 15 - 25.1
       ignitionDegree = {{param3x}} * rpm + ({{param3y}});
     }
     if (rpm >= 3000 && rpm <= 4000) {// 25.1 - 33.7
       ignitionDegree = {{param4x}} * rpm + ({{param4y}});
     }
     if (rpm > 4000) {
       ignitionDegree = {{param5}};
     }

    if (ignitionDegree > 0){
      countIgnitionTime();  
    }
    oldtime=micros();
  }
}
`
